// extracted by mini-css-extract-plugin
module.exports = {"container":"eventPage_container__3hNtP"};